import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Pagination from "../../common/Pagination";
import DownloadHistoryItem from "../items/DownloadHistoryItem";
import { buildSummaryKey } from "../../../utils/downloadHistoryUtils";
import { DOWNLOAD_HISTORY_PER_PAGE } from "../../../constants/Constants";

const styles = () => ({
  root: {
    width: "80%",
    margin: 'auto',
    boxSizing: "border-box",
  },

  itemContainer: {
    boxShadow: '0px 0px 3px #00000026',
  },

  paginationContainer: {
    margin: "40px 0px 80px 0px",
  },
});

class ResultSection extends React.Component {
  render() {
    const { classes, pageInfo, downloadHistory, isLoading } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.itemContainer}>
          {(downloadHistory.valueSeq().map(order => (
            <DownloadHistoryItem
              key={buildSummaryKey(order)}
              order={order}
              onShowDetail={this.props.onShowDetail}
            />
          )))}
        </div>
        {downloadHistory.size > 0 && pageInfo && (
          <div className={classes.paginationContainer}>
            <Pagination
              currentPage={pageInfo.current_page}
              lastPage={pageInfo.last_page}
              total={pageInfo.total}
              perPage={DOWNLOAD_HISTORY_PER_PAGE}
              showLastPage={false}
              disabled={isLoading}
              onChange={(data) => {
                this.props.getDownloadHistory({
                  page: data.page,
                  per_page: data.per_page,
                });
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

ResultSection.propTypes = {
  classes: PropTypes.object.isRequired,
  getDownloadHistory: PropTypes.func.isRequired,
  downloadHistory: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageInfo: PropTypes.object.isRequired,
  onShowDetail: PropTypes.func.isRequired,
};

export default withStyles(styles)(ResultSection);



// WEBPACK FOOTER //
// ./src/components/DownloadHistory/sections/ResultSection.jsx